"use strict";

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty2(exports, "__esModule", {
  value: true
});
exports.getDateLocale = getDateLocale;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));
var _weakMap = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/weak-map"));
var _defineProperty = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/define-property"));
var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor"));
var _importDateFnsLocale = require("../import-date-fns-locale");
function _getRequireWildcardCache(e) { if ("function" != typeof _weakMap.default) return null; var r = new _weakMap.default(), t = new _weakMap.default(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _defineProperty.default && _getOwnPropertyDescriptor.default; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? (0, _getOwnPropertyDescriptor.default)(e, u) : null; i && (i.get || i.set) ? (0, _defineProperty.default)(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Dynamically loads the locale module for the given locale code.
 *
 * @param {string} localeCode - The locale code to load (e.g., 'en-US', 'fr-CA').
 * @returns {Promise<Locale>} - A promise that resolves to the locale module.
 */
async function getDateLocale(localeCode) {
  try {
    const module = await (0, _importDateFnsLocale.importDateFnsLocale)(localeCode);
    return module.default;
  } catch (error) {
    return importDefaultLocale();
  }
}
async function importDefaultLocale() {
  const defaultModule = await _promise.default.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "date-fns-locale-en-US" */'date-fns/locale/en-US')));
  return defaultModule.default;
}